import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';
import { d as dateFnsExports } from './p-iWCgRMLC.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$b } from './p-D5W-FK48.js';
import { d as defineCustomElement$a } from './p-sF9rvBC9.js';
import { d as defineCustomElement$9 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$8 } from './p-DKss2Fy6.js';
import { d as defineCustomElement$7 } from './p-lnuA9A6c.js';
import { d as defineCustomElement$6 } from './p-BGrwcTZq.js';
import { d as defineCustomElement$5 } from './p-BXP_PKKm.js';
import { d as defineCustomElement$4 } from './p-BYQE4OHw.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const pageHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--jw-theme-surface-elevated-default-bg-color);box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .header-container{align-items:flex-start;align-self:stretch;display:flex;flex-direction:column;gap:.75rem;padding:1.5rem}:host .top-content-container{display:flex;gap:.75rem;justify-content:space-between;width:100%}:host .left-header-container{align-items:center;display:flex;gap:.75rem}:host .right-header-container{align-items:center;display:flex;gap:1rem;white-space:nowrap}:host .title-container{align-items:center;display:inline-grid;gap:.125rem;grid-template-columns:minmax(11rem,1fr) auto}:host .title-container:has(h1~h1){grid-template-columns:minmax(4rem,auto) auto minmax(11rem,1fr) auto}:host .last-saved-timestamp{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem}:host .current-page-title-container{background:none;border:none;cursor:auto;display:flex;gap:.125rem;height:auto;margin:0;padding:0;width:auto}:host wui-icon{color:var(--jw-theme-surface-text-helper-color)}:host h1{font-family:Open Sans;font-size:1.5rem;font-weight:400;letter-spacing:-.0008em;line-height:2rem;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host h1.page-title{color:var(--jw-theme-surface-text-default-color)}:host h1.parent-title{color:var(--jw-theme-surface-text-helper-color);white-space:nowrap}:host ::slotted([slot=subtitleSection]){width:100%}:host .header-tabs-container{border-bottom:1px solid var(--jw-theme-surface-border-border-color);padding:0 1.5rem}:host .header-tabs-container wui-tabs{box-shadow:none}@media only screen and (max-width:48rem){.top-content-container{flex-wrap:wrap;gap:.75rem}.right-header-container{align-self:flex-end;margin-left:auto}}";

const WuiPageHeader$1 = /*@__PURE__*/ proxyCustomElement(class WuiPageHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Current page title
         *
         */
        this.currentPageTitle = '';
        /**
         * Page description, displayed underneath title
         *
         * If more advanced markup is required, use the `description` slot.
         */
        this.description = '';
        /**
         * Array of buttons to be shown as action menu
         *
         */
        this.menu = [];
    }
    renderLastSavedTimestamp() {
        if (!this.lastSaved)
            return null;
        return h("span", { class: "last-saved-timestamp" }, "Last saved ", dateFnsExports.formatDistanceToNow(this.lastSaved), " ago");
    }
    render() {
        return (h(Host, { key: 'f6ec52f565257475fa120bf5b42be328ee36f9c9' }, h("header", { key: '02184e3e15993ac8af642d97c0e5782fa02059ef', class: "header-container" }, h("section", { key: '20ebc8193b1a477bad2c35b1aec9fec12e25eac8', class: "top-content-container" }, h("div", { key: 'a91b624bbecbd065a89500fc28bf6eab24c513cd', class: "left-header-container" }, this.parentLink && (h("wui-button", { key: '57ea95ec10cd62ceb32d4c460773c7399922ebf4', icon: "arrow-left", type: "icon-ghost", "data-test": "link-to-previous-page", as: ['a', { ...parseHrefProp(this.parentLink.href) }], tooltip: this.parentLink.title ? `Go back to ${this.parentLink.title}` : 'Go back' })), h("div", { key: '974b3a664a481b60f45bd6f84d19144c4a2d8590', class: "title-container" }, this.parentLink?.title && (h(Fragment, { key: '0369ee49c9c1605258df9ee67f44d35550bcc83a' }, h("h1", { key: '75c0395cc741a8194f7c8ea1018d66c718adb9a9', class: "parent-title", title: this.parentLink.title }, this.parentLink.title), h("wui-icon", { key: 'a42f69e9cd3a61be6ad27d968d1b1f6f302477f0', name: "slash", size: "xl" }))), h("h1", { key: '275393d5a56d50ed4ddfb3a22baeac6dd3ee6e15', class: "page-title", title: this.currentPageTitle }, this.currentPageTitle)), this.tag && h("wui-tag", { key: 'cd6abacc8f3f841928701c00516e2a035946f976', label: this.tag })), h("div", { key: '1ee4943661ff4c2a9f9a6f9483e5c1720b530333', class: "right-header-container" }, this.renderLastSavedTimestamp(), h("slot", { key: '89f71121d9c2e2b26a2258a7e19b2acc96f1e304', name: "status" }), (this.menu?.length ?? 0) > 0 && (h("wui-layout", { key: '3c9f270e0d9231f1ee68718682eb8403c41b41fc', type: "button-group", variant: "button-group-content-container" }, this.menu?.map((buttonProps, idx) => (h("wui-button", { key: `menu-button-${idx}`, ...buttonProps }))))))), this.description || h("slot", { key: '6d88e82c205b2588b88b0981cef9e699d961d5be', name: "description" })), h("section", { key: 'c58dc18db836e181036e1d0886e766f117e36a15', class: "header-tabs-container" }, this.tabs && h("wui-tabs", { key: '8b61adba7ebbecdddddab1cf3c9b26c50a2afbe7', ...this.tabs }))));
    }
    get elm() { return this; }
    static get style() { return pageHeaderCss; }
}, [257, "wui-page-header", {
        "currentPageTitle": [1, "current-page-title"],
        "description": [1],
        "parentLink": [16, "parent-link"],
        "menu": [16],
        "tag": [1],
        "lastSaved": [16, "last-saved"],
        "tabs": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-page-header", "wui-button", "wui-close-button", "wui-icon", "wui-layout", "wui-loader", "wui-tab", "wui-tabs", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-page-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiPageHeader$1);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-tab":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tabs":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiPageHeader = WuiPageHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPageHeader, defineCustomElement };
